import React from 'react'
import { Outlet } from 'react-router-dom'

function MainContacts() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainContacts
